import { createStore } from 'vuex'
import technician from './modules/technician'
import config from './modules/config'
import utils from './modules/utils'
import { AppState } from '../models/TechnicianAppState';
import login from './modules/login';
import jobs from './modules/jobs';
import { STATE_MODULES } from '@/store/state-modules';
import leads from './modules/leads';
import quote from './modules/quote';

export default createStore<AppState>({
	modules: {
		[STATE_MODULES.CONFIG]: config,
		[STATE_MODULES.TECHNICIAN]: technician,
		[STATE_MODULES.UTILS]: utils,
		[STATE_MODULES.LOGIN]: login,
		[STATE_MODULES.JOBS]: jobs,
		[STATE_MODULES.LEADS]: leads,
		[STATE_MODULES.QUOTE]: quote
	}
})
